  import Pricing from "../components/pricing/pricing";
  import Footer from "../components/Footer/Footer";
export default function PricingPage() {
  return (
    <>
      <Pricing />
      <Footer />
    </>
  );
}